export default __webpack_public_path__ + "static/media/Long Strangle.9f0f218e.svg";